<template>

  <div class="filters">
    <div>
      <date-range-picker v-model="filters.interval" :time="false"></date-range-picker>
    </div>

    <div>
      <div class="autocomplete d-flex align-center">
        <v-select :items="types" v-model="filters.type" item-text="label" item-value="value" :label="$t('interventions.type')"></v-select>

        <div class="icon" v-if="filters.type">
          <v-btn text icon @click="filters.type = null">
            <v-icon>delete</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div>
      <asset-types-tree v-model="filters.assetTypes"></asset-types-tree>
    </div>

    <div>
      <assets-tree v-model="filters.assets"></assets-tree>
    </div>

    <div>
      <users-select v-model="filters.users" :clearable="true"></users-select>
    </div>
  </div>

</template>

<script>
  import {mapMutations, mapState} from 'vuex'
  import DateRangePicker from '../../shared/components/date-range-picker'
  import UsersSelect from '../../users/components/users-select'
  import AssetTypesTree from '../../asset-types/asset-types-tree'
  import AssetsTree from '../../assets/components/assets-tree'


  export default {
    name: 'interventions-filters',

    data () {
      return {
        types: [
          { label: 'Maintenance', value: 'maintenance' },
          { label: 'Failure', value: 'failure' },
          { label: 'Closed', value: 'closed' }
        ]
      }
    },

    computed: {
      ...mapState('filters/interventions', [
        'filters'
      ]),
    },

    methods: {
      ...mapMutations('filters/interventions', [
        'saveFilters'
      ])
    },

    watch: {
      filters: {
        deep: true,
        handler () {
          this.saveFilters(this.filters)
          this.$emit('change', this.filters)
        }
      }
    },

    components: {
      AssetTypesTree,
      AssetsTree,
      UsersSelect,
      DateRangePicker
    }
  }
</script>

<style scoped lang="scss">


</style>
